/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PhysicalPrepaidCardSettingResponse } from '../models/PhysicalPrepaidCardSettingResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PhysicalPrepaidCardSettingRepository {

  /**
   * 物理プリペイドカード設定値取得
   * @returns PhysicalPrepaidCardSettingResponse OK
   * @throws ApiError
   */
  public static get(): CancelablePromise<PhysicalPrepaidCardSettingResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/physical_prepaid_card_setting',
      errors: {
        404: `Not Found`,
      },
    });
  }

}
